export const emptyToNull = (value) => (value === '' ? null : value)

export const toNumber = (value) => (Number.isNaN(value) ? undefined : value)
